import { Link } from "react-router"
import { useQuery } from "@tanstack/react-query"

import { api } from "@/lib/api"
import { audienceHint, audienceLabel } from "@/lib/audienceLabels"
import { SectionCard } from "@/components/console/SectionCard"
import { PageSkeleton, FetchError } from "@/components/console/Fallbacks"

export function Home({ token }: { token: string }) {
  const audiences = useQuery({
    queryKey: ["audiences", token],
    queryFn: () => api.audiences(token),
  })

  if (audiences.isPending) return <PageSkeleton />
  if (audiences.isError) return <FetchError error={audiences.error} retry={() => audiences.refetch()} />

  return (
    <div className="space-y-3">
      <SectionCard title="knowledge bases">
        {audiences.data.length === 0 ? (
          <p className="font-mono text-xs text-muted-foreground">
            Nothing here is shared with your account yet.
          </p>
        ) : (
          <ul className="space-y-1">
            {audiences.data.map((a) => (
              <li key={a.id}>
                <Link
                  to={`/audiences/${encodeURIComponent(a.id)}`}
                  className="font-mono text-xs text-foreground hover:underline"
                >
                  {audienceLabel(a.id)}
                </Link>
                {audienceHint(a.id) ? (
                  <span className="ml-2 text-[10px] text-muted-foreground">
                    {audienceHint(a.id)}
                  </span>
                ) : null}
                {a.can_write ? (
                  <span className="ml-2 text-[10px] text-muted-foreground">steward</span>
                ) : null}
              </li>
            ))}
          </ul>
        )}
      </SectionCard>
    </div>
  )
}
